import callApi from 'services/api'
import React, { useEffect, useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { AlertState } from 'global/AlertState'

import { useFormik } from 'formik'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { loadingState } from 'global/LoaderState'
import * as Yup from 'yup'

const AddMasterData = ({
  selected,
  editingData,
  handleCloseModal,
  selectedName,
  fetchList,
}) => {
  const [parent, setParents] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [, setAlertMessage] = useRecoilState(AlertState)
  const loader = useSetRecoilState(loadingState)

  const [initialValues, setInitialValues] = useState({
    name: '',
    description: '',
    type: '',
    parentId: [],

  })

  const validationSchema = Yup.object({
    name: Yup.string().required('Name is required'),
    parentId: Yup.array().when('type', {
      is: (val) => val === 'sub_unit',
      then: (schema) => schema.min(1, 'Unit is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  })
  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setLoading(true)

      const url = editingData
        ? `filtermaster/${editingData.id}/`
        : 'filtermaster/'

      const method = editingData ? 'PUT' : 'POST'


      const response = await callApi(url, method, values, true, true)

      if (response.success) {
        fetchList(selected?.id)
        handleCloseModal()
      }
      setLoading(false)
    },
  })

  const getParentList = async (value) => {
    try {
      setLoading(true)
      setError(null)

      const params = new URLSearchParams({
        filter: JSON.stringify({ type: value }),
        sort_order: '1',
      })
      const response = await callApi(
        `filtermaster/list?${params}`,
        'GET',
        null,
        true,
        true,
        (msg) => setError(msg),
        (path) => console.log('navigate to', path)
      )

      if (response.success) {
        setParents(response.body)
      }
    } catch (err) {
      setError(err.message || 'Failed to load filters')
    } finally {
      setLoading(false)
    }
  }

  const handleParentChange = (e) => {
    formik.setFieldValue(
      'parentId',
      Array.from(e.target.selectedOptions, (opt) => opt.value)
    )
  }

  const fetchData = async (id) => {
    try {
      const response = await callApi(
        `filtermaster/${id}`,
        'GET',
        null,
        true,
        true
      )

      // console.log(`fetch data:`)
      // console.log(response)

      // map API response into form values
      setInitialValues({
        name: response?.body?.name || '',
        description: response?.body?.description || '',
        type: response?.body?.type || '',
        parentId: response?.body?.parentId || [],

      })
    } catch (err) {
      console.error('Failed to fetch data', err)
    }
  }
  useEffect(() => {
    try {
      if (editingData) {
        loader(true)
        fetchData(editingData?.id)
      } else {
        setInitialValues({
          name: '',
          description: '',
          type: selected?.id || '',
          parentId: [],

        })
      }
    } catch (error) {
    } finally {
      loader(false)
    }

    if (selected?.hasParent) {
      getParentList(selected.parent_filter[0])
    }
  }, [selected, editingData])
  return (
    <>
      {/* <pre>{JSON.stringify(selected, null, 2)}</pre>
      <pre>{JSON.stringify(formik.values, null, 2)}</pre> */}
      <div className="row justify-content-center">
        <div>
          <form onSubmit={formik.handleSubmit}>
            {['name', 'description'].map((field) => (
              <div className="form-group row mb-3" key={field}>
                <label
                  htmlFor={field}
                  className="col-sm-4 col-form-label"
                  style={{ textTransform: 'capitalize' }}
                >
                  {field}:
                  {field !== 'description' && (
                    <>
                      <span className="text-danger">*</span>
                    </>
                  )}
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    id={field}
                    name={field}
                    className="form-control"
                    placeholder={field}
                    autoComplete={field}
                    value={formik.values[field]}
                    onChange={formik.handleChange}
                    onBlur={(e) => {
                      formik.handleBlur(e);
                      formik.setFieldValue(field, e.target.value.trim());
                    }}
                  />
                  {formik.touched[field] && formik.errors[field] && (
                    <div className="text-danger">{formik.errors[field]}</div>
                  )}
                </div>
              </div>
            ))}

            {selected?.hasParent && (
              <>
                <div className="form-group row mb-3">
                  <label
                    htmlFor="parentId"
                    className="col-sm-4 col-form-label"
                    style={{ textTransform: 'capitalize' }}
                  >
                    {selected.parent_filter
                      ?.toString()
                      ?.replace(/_/g, ' ')
                      ?.replace(/\b\w/g, (c) => c.toUpperCase())}

                    <span className="text-danger">*</span>
                  </label>
                  <div className="col-sm-8">
                    <select
                      name="parentId"
                      className="form-control"
                      id="parentId"
                      style={{ width: '100%' }}
                      onChange={handleParentChange}
                      value={formik.values.parentId || []}
                      disabled={loading}
                    >
                      <option value="">Select an option...</option>

                      {parent.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.name}
                        </option>
                      ))}
                    </select>
                    {formik.touched.parentId && formik.errors.parentId && (
                      <div className="text-danger">
                        {formik.errors.parentId}
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}





            <div className="d-flex justify-content-center mt-4">
              <button
                type="button"
                className="btn btn-secondary me-2"
                onClick={handleCloseModal}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading && (
                  <>
                    <FontAwesomeIcon icon={faSpinner} className="me-2" />
                  </>
                )}
                {editingData
                  ? `Update${selectedName ? ` ${selectedName}` : ''}`
                  : `Add${selectedName ? ` ${selectedName}` : ''}`}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}
export default AddMasterData
